module.exports = __webpack_public_path__ + "img/vertical_3_6_8004.e8f59337.png";